import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class PrintService {
  isPrinting = false;
  constructor(private swUpdate: SwUpdate,private router: Router) {
    swUpdate.available.subscribe(event => {
      if (confirm("New Updates Available. ")) {

        window.location.reload();
      }else{
        window.location.reload();

      }
    });
  }

  printDocument(documentName: string, documentData: string[]) {
    // console.log('document data= ',documentData)
    this.isPrinting = true;
    this.router.navigate(['/',
      {
        outlets: {
          'print': ['print', documentName, documentData.join()]
        }
      }
    ]);
  }

  onDataReady() {
    setTimeout(() => {
      window.print();
      this.isPrinting = false;
      this.router.navigate([{ outlets: { print: null }}]);
    });
  }
}
